<script>import { melt } from "@melt-ui/svelte";
import { ctx } from "../ctx.js";
import { disabledAttrs } from "../../../internal/helpers.js";
export let asChild = false;
export let disabled = false;
const item = ctx.get().elements.item;
</script>

<!-- svelte-ignore a11y-no-static-element-interactions applied by melt's action/store -->
{#if asChild}
	<slot builder={$item} />
{:else}
	{@const builder = $item}
	<div
		{...builder} use:builder.action
		{...$$restProps}
		on:m-click
		on:m-focusin
		on:m-focusout
		on:m-keydown
		on:m-pointerdown
		on:m-pointerleave
		on:m-pointermove
		{...disabledAttrs(disabled)}
	>
		<slot {builder} />
	</div>
{/if}
